import SigninRoute from "@/billing/routes/SigninRoute"

export default SigninRoute
